<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"></ngx-loading>
<ng-template #customLoadingTemplate></ng-template>
<div class="app-content content">
	<div class="content-wrapper">
		<div class="content-detached">
			<div class="content-body">
				<!-- FILTRO-->
				<app-search-bar [criterioPrincipal]="configLocal.barraBusqueda.criterioPrincipal" [config]="configLocal.barraBusqueda" (busqueda)="searchElementsByFilter($event)" [useAccordionMode]="true" [useInlineSearchButton]="true" [useInlineDeactivatedCheckbox]="true" [registroActivacion]="true"> </app-search-bar>
				<div class="row">
					<div class="col-12">
						<div class="card card-custom">
							<div class="card-header">
								<h4 class="card-title">Resellers</h4>
							</div>
							<div class="card-head">
								<div class="heading-elements mt-0">
									<button class="btn btn-success float-right mt-5 mr-5" (click)="openAddResellerModal(addResellerModal)">Agregar Reseller</button>
								</div>
							</div>
							<div class="card-content">
								<div class="card-body">
									<ngx-datatable #table class="material" [rows]="rowsMantenedor" [columnMode]="'flex'" [headerHeight]="50" [footerHeight]="50" [rowHeight]="70" fxFlex="auto" [externalPaging]="true" [count]="page.totalElements" [offset]="page.pageNumber" [limit]="page.pageSize" (page)="setPage($event)" [messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }">
										<ngx-datatable-column name="rutCompleto" [flexGrow]="1.5" [sortable]="false" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Rut</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{ row.rutCompleto }}</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="razonSocial" [flexGrow]="5" [sortable]="false" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Razón Social</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{ row.razonSocial }}</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="nombreContacto" [flexGrow]="4" [sortable]="false" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Nombre Contacto</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{ row.nombreContacto }}</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="cantidadEmpresasAsociadas" [flexGrow]="2" [sortable]="false" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Empresas Asociadas</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{ row.cantidadEmpresasAsociadas }}</span>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="Acciones" [flexGrow]="3" [sortable]="false" [resizeable]="false">
											<ng-template ngx-datatable-cell-template let-row="row">
												<a class="primary edit mr-1 mrless" ngbTooltip="Detalles de Reseller" id="mantenedor-resellers.component_Detalles_de_Reseller" (click)="openDetailsResellerModal(detailResellerModal, row)">
													<div class="icon-circle bg-warning text-center align-middle pt-info-button">
														<fa-icon icon="info-circle" class="fa-lg text-white"></fa-icon>
													</div>
												</a>

												<a class="primary edit mr-1 mrless" ngbTooltip="Editar Reseller" id="mantenedor-resellers.component_Editar_Reseller" (click)="openEditResellerModal(editResellerModal, row)">
													<div class="icon-circle bg-info text-center align-middle pt-info-button">
														<fa-icon icon="pencil-alt" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a class="primary edit mr-1 mrless" ngbTooltip="Empresas Asociadas" id="mantenedor-resellers.component_Emisores_Asociados" (click)="openResellerEmisoresModal(emisoresOfReseller, row)">
													<div class="icon-circle bg-primary text-center align-middle pt-info-button">
														<fa-icon icon="object-group" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a
													*ngIf="row.activo"
													class="danger edit mr-1 mrless"
													ngbTooltip="Desactivar Reseller"
													[swal]="{
														title: 'Confirmación',
														text: '¿Está seguro de desactivar este reseller?',
														confirmButtonText: 'Desactivar',
														cancelButtonText: 'Cancelar',
														showCancelButton: true,
														confirmButtonColor: '#F64E60'
													}"
													(confirm)="deactivateReseller(row)">
													<div class="icon-circle bg-danger text-center align-middle pt-info-button">
														<fa-icon icon="times-circle" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a
													*ngIf="!row.activo"
													class="danger edit mr-1 mrless"
													ngbTooltip="Reactivar Reseller"
													[swal]="{
														title: 'Confirmación',
														text: '¿Está seguro de reactivar este Reseller?',
														confirmButtonText: 'Reactivar',
														cancelButtonText: 'Cancelar',
														showCancelButton: true,
														confirmButtonColor: '#1BC5BD'
													}"
													(confirm)="reactivateReseller(row)">
													<div class="icon-circle bg-success text-center align-middle pt-info-button">
														<fa-icon icon="check-circle" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-footer>
											<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
												<div class="col-auto">Elementos por página</div>
												<div class="mr-5">
													<ng-select [(ngModel)]="page.pageSize" [items]="page.pageSizes" [clearable]="false" (change)="setPageSize()" dropdownPosition="top" style="overflow: visible" appendTo="datatable-footer">
														<option *ngFor="let option of page.pageSizes" [value]="option"></option>
													</ng-select>
												</div>
												<div class="ml-5 col-auto divisor-footer">
													<div class="page-count">{{ rowCount }} Elementos totales</div>
												</div>
												<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="table.onFooterPage($event)"> </datatable-pager>
											</ng-template>
										</ngx-datatable-footer>
									</ngx-datatable>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<ng-template #addResellerModal let-d="dismiss" let-c="close">
	<div class="modal-lg">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Ingreso de Reseller</div>
				<div class="modal-wizard-desc">Ingrese los datos del reseller que utilizará la plataforma</div>
			</div>
		</div>
		<div class="modal-body">
			<app-reseller-entry (sendCloseRequestEmitter)="closeModal()" (sendResellerRequestEmitter)="addReseller($event)"></app-reseller-entry>
		</div>
	</div>
</ng-template>

<ng-template #editResellerModal let-d="dismiss" let-c="close">
	<div class="modal-lg">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Edición de Reseller</div>
				<div class="modal-wizard-desc">Modifique los datos del reseller seleccionado</div>
			</div>
		</div>
		<div class="modal-body">
			<app-reseller-entry [editMode]="true" [detailMode]="false" [resellerToEdit]="selectedReseller" (sendCloseRequestEmitter)="closeModal()" (sendResellerRequestEmitter)="editReseller($event)"> </app-reseller-entry>
		</div>
	</div>
</ng-template>

<ng-template #detailResellerModal let-d="dismiss" let-c="close">
	<div class="modal-lg">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Detalles de Reseller</div>
				<div class="modal-wizard-desc">Se muestran los detalles del reseller seleccionado</div>
			</div>
		</div>
		<div class="modal-body">
			<app-reseller-entry [editMode]="false" [detailMode]="true" [resellerToEdit]="selectedReseller" (sendCloseRequestEmitter)="closeModal()"> </app-reseller-entry>
		</div>
	</div>
</ng-template>

<ng-template #emisoresOfReseller let-d="dismiss" let-c="close">
	<div class="modal-lg">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Asignación de Empresas</div>
				<div class="modal-wizard-desc">Se muestran las empresas gestionadas bajo el reseller</div>
			</div>
			<button class="btn btn-success float-right ml-15 mt-5" (click)="assignEmisoresModal(assignEmisoresList)">
				<i class="flaticon-add-circular-button"></i>
				Asignar Empresas
			</button>
			<button class="btn btn-warning float-right mr-5 mt-5" (click)="showUnassignResume()" ngbTooltip="Seleccione emisores(empresas) que desee desvincular del actual Reseller">
				<i class="flaticon-add-circular-button"></i>
				Liberar Empresas
			</button>
		</div>
		<div class="modal-body">
			<ngx-datatable
				class="material"
				[rows]="rowsEmisoresReseller"
				[columnMode]="'flex'"
				[headerHeight]="50"
				[footerHeight]="50"
				[rowHeight]="70"
				fxFlex="auto"
				[externalPaging]="true"
				[count]="emisoresResellerPage.totalElements"
				[offset]="emisoresResellerPage.pageNumber"
				[limit]="emisoresResellerPage.pageSize"
				(page)="setPageEmisoresReseller($event)"
				[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }"
				[selectionType]="'checkbox'"
				[selected]="selectedEmisorReseller"
				(selected)="onSelect($event)">
				<ngx-datatable-column [width]="40" [sortable]="false" [canAutoResize]="false" [draggable]="false" [resizeable]="false">
					<ng-template ngx-datatable-header-template let-value="value">
						<input type="checkbox" class="customCheckbox" [checked]="selectedAllEmisorsOfResellerInPage[page.pageNumber]" (change)="selectAllEmisorReseller($event)" />
					</ng-template>
					<ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected" let-onCheckboxChangeFn="onCheckboxChangeFn">
						<input type="checkbox" class="customCheckbox" [checked]="isSelected" (change)="onCheckboxChangeFn($event)" />
					</ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="nombre" [flexGrow]="4" [sortable]="true" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
					<ng-template let-column="column" ngx-datatable-header-template>
						<span class="text-table-alignment">Rut</span>
					</ng-template>
					<ng-template ngx-datatable-cell-template let-row="row"
						><span class="text-table-alignment">{{ row.rutString }}</span>
					</ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="nombre" [flexGrow]="4" [sortable]="true" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
					<ng-template let-column="column" ngx-datatable-header-template>
						<span class="text-table-alignment">Razón Social</span>
					</ng-template>
					<ng-template ngx-datatable-cell-template let-row="row"
						><span class="text-table-alignment">{{ row.razonSocial }}</span>
					</ng-template>
				</ngx-datatable-column>
			</ngx-datatable>
		</div>
		<div class="modal-footer">
			<!-- <button type="submit" id="add-contact-item" class="btn btn-success add-contact-item">
                    <i class="la la-paper-plane-o d-lg-none"></i>
                    <span class="d-none d-lg-block">Guardar</span>
                </button> -->
			<button type="button" class="btn btn-secondary ml-3" (click)="d('Cross click')">
				<span class="d-none d-lg-block">Cerrar</span>
			</button>
		</div>
	</div>
</ng-template>

<ng-template #assignEmisoresList let-d="dismiss" let-c="close">
	<div class="modal-lg">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Lista de Emisores</div>
				<div class="modal-wizard-desc">Seleccione emisores para ser gestionados por el Reseller</div>
			</div>
		</div>
		<div class="modal-body">
			<ngx-datatable
				class="material"
				[rows]="rowsEmisoresFull"
				[columnMode]="'flex'"
				[headerHeight]="50"
				[footerHeight]="50"
				[rowHeight]="70"
				fxFlex="auto"
				[externalPaging]="true"
				[count]="fullEmisorPage.totalElements"
				[offset]="fullEmisorPage.pageNumber"
				[limit]="fullEmisorPage.pageSize"
				(page)="setPageEmisoresReseller($event)"
				[selectionType]="'checkbox'"
				[selected]="selected"
				(selected)="onSelect($event)"
				[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }">
				<ngx-datatable-column [width]="40" [sortable]="false" [canAutoResize]="false" [draggable]="false" [resizeable]="false">
					<ng-template ngx-datatable-header-template let-value="value">
						<input type="checkbox" class="customCheckbox" [checked]="selectedAllEmisorsFullInPage[fullEmisorPage.pageNumber]" (change)="selectAll($event)" />
					</ng-template>
					<ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected" let-onCheckboxChangeFn="onCheckboxChangeFn">
						<input type="checkbox" class="customCheckbox" [checked]="isSelected" (change)="onCheckboxChangeFn($event)" />
					</ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="nombre" [flexGrow]="4" [sortable]="true" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
					<ng-template let-column="column" ngx-datatable-header-template>
						<span class="text-table-alignment">Rut</span>
					</ng-template>
					<ng-template ngx-datatable-cell-template let-row="row"
						><span class="text-table-alignment">{{ row.rutString }}</span>
					</ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="nombre" [flexGrow]="4" [sortable]="true" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
					<ng-template let-column="column" ngx-datatable-header-template>
						<span class="text-table-alignment">Razón Social</span>
					</ng-template>
					<ng-template ngx-datatable-cell-template let-row="row"
						><span class="text-table-alignment">{{ row.razonSocial }}</span>
					</ng-template>
				</ngx-datatable-column>
			</ngx-datatable>
		</div>
		<div class="modal-footer">
			<button type="submit" id="add-contact-item" class="btn btn-success add-contact-item" (click)="assignEmisores()">
				<i class="la la-paper-plane-o d-lg-none"></i>
				<span class="d-none d-lg-block">Guardar</span>
			</button>
			<button type="button" class="btn btn-secondary ml-3" (click)="d('Cross click')">
				<span class="d-none d-lg-block">Cerrar</span>
			</button>
		</div>
	</div>
</ng-template>
